export default __webpack_public_path__ + "static/media/Capture2.ca06c084.JPG";